import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/services';
import { Store } from '@ngrx/store';
import { selectIsAuthenticated, selectUserRole } from '@app/core/store/auth/auth.selectors';
import { take, Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-header',
    styleUrls: [
        'header.component.scss'
    ],
    templateUrl: 'header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthenticationService,
    private store: Store
  ) { }

  navbarOpen = false;
  unsubscribe$ = new Subject();
  isAuthenticated$!: Observable<boolean>;
  role$!: Observable<string>;

  ngOnInit() {
    this.subscribeToLogin();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  subscribeToLogin() {
    this.isAuthenticated$ = this.store.select(selectIsAuthenticated).pipe(takeUntil(this.unsubscribe$));

    this.role$ = this.store.select(selectUserRole).pipe(takeUntil(this.unsubscribe$));
  }

  logOut() {
    this.authService.logOut();
  }
}
